import axios from 'axios';
import {API} from "@/services/url";

export default {
	getVersionList:function (success, error) {
		axios.get(API.version.versionList).then(
			r => success(r.data.versionList)
		).catch(
			e => error(e.response.data.message)
		);
	},
	getVersionNameList:function (success, error) {
		axios.get(API.version.versionNameList).then(
			r => success(r.data.versionNameList)
		).catch(
			e => error(e.response.data.message)
		);
	},
	saveConfiguration: (data, success, error) => {
		axios.post(API.version.versionConfigure, data).then(
			r => success(r.data)
		).catch(
			e => error(e.response.data.message)
		);
	}
}
